import React from 'react';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { toBrDateWithTime } from '../../../../utils/dateUtils';
import TabInfoComp from './tinyComps/tab_info_tab_comp';
import ImageWithModal from './tinyComps/image_with_modal';

const PAChecklistFollowUpRevTab = () => {
  const { itemSelecionado, infoComp } = usePAChecklistFollowUp();

  const direcionamento_revisao_columns = [
    { name: 'Destino', selector: row => row.descricao_destino, width: '200px' },
    { name: 'Qtde. Peças', selector: row => row.qtde_pecas, width: '100px' },
    { name: 'Tamanho', selector: row => row.descricao_grade, width: '100px' },
    { name: 'Defeito', selector: row => row.defeito }
  ];

  const grade_columns = [
    { name: 'Tamanho', selector: row => row.tamanho },
    { name: 'Quantidade', selector: row => row.quantidade_total }
  ];

  return (
    <section className={styles.inner_tab_wrapper}>
      {
        !itemSelecionado.revisao_ok &&
        <div className={styles.no_data_message}>Análise revisão ainda não realizada</div>
      }
      {
        itemSelecionado.revisao_ok &&
        <>
          <TabInfoComp
            tabData={[
              { label: 'Data Revisão:', value: toBrDateWithTime(itemSelecionado.data_revisao) },
              { label: 'Usuário Revisão:', value: itemSelecionado.usuario_responsavel_revisao},
              { label: 'Status Revisão:', value: itemSelecionado.status_revisao},
            ]}
          />

          <div className={styles.separator} />

          <div>
            <div className={styles.section_label}>Grade (somente conferência)</div>
            <Tabela
              columns={grade_columns}
              data={itemSelecionado.grade}
              pagination={false}
            />
          </div>

          <div className={styles.separator} />

          {
            itemSelecionado.revisaoDirecionamentos.length === 0 &&
            <div className={styles.section_label}>Nenhum direcionamento inserido</div>
          }
          {
            itemSelecionado.revisaoDirecionamentos.length > 0 &&
            <div style={{ width: '100%', margin: 'auto' }}>
              <div className={styles.section_label}>Direcionamentos</div>
              <Tabela
                columns={direcionamento_revisao_columns}
                data={itemSelecionado.revisaoDirecionamentos}
                pagination={false}
                highlightOnHover={true}
              />
            </div>
          }

          <div className={styles.separator} />

          {
            itemSelecionado.resRevisaoImagens.length === 0 &&
            <div className={styles.section_label}>Nenhuma imagem inserida</div>
          }
          {
            itemSelecionado.resRevisaoImagens.length > 0 &&
            <div style={{ width: '100%', margin: 'auto' }}>

              <div className={styles.section_label}>Imagens</div>
              <section className={styles.flex_row_wrapper}>
                {itemSelecionado.resRevisaoImagens.map((src, i) => {
                  return <ImageWithModal key={i} src={src} i={i} />
                })}
              </section>
            </div>
          }
        </>
      }
    </section>
  );
}

export default PAChecklistFollowUpRevTab;
